<ui-table
  [title]="'translate.order.chatTasks'"
  [isWrapped]="true"
  [dense]="true"
  [data]="order.chatTasks"
  [rowHover]="false"
  [showPaginator]="false"
  [displayFilter]="['taskTitle']"
  [topEnd]="newTaskLink"
  [templates]="[
    {
      title: 'translate.general.statusDescr',
      template: status
    },
    {
      title: 'translate.general.ownerUserDescr',
      template: ownerUserDescr
    },
    {
      title: 'translate.tasks.edit',
      colClass: 'l-ta-center',
      template: editBtn
    }
  ]"
></ui-table>

<ng-template #status let-row="row">
  {{ row.status.text }}
</ng-template>

<ng-template #ownerUserDescr let-row="row">
  <span *ngIf="row.owner">{{ row.owner.userDescr }}</span>
</ng-template>

<ng-template #editBtn let-row="row">
  <button class="btn-editUser" (click)="editTask(row)"></button>
</ng-template>

<ng-template #newTaskLink>
  <a (click)="createTask()" class="note"
    >+ {{ "translate.order.createTask" | translate }}</a
  >
</ng-template>
